export const extraMessageErrorSaveDocument = () => '';
